import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../utils/config";
import { Box } from "@mui/material";
import Download from "../components/Download";
import { formLabel } from "../utils/formFieldLabels";
import ErrorMessage from "../components/ErrorMessage";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { initialFormData } from "../utils/formData";
import Paper from "@mui/material/Paper";
import AdmissionFormStatus from "./AdmissionFormStatus";
import { GoXCircleFill, GoCheckCircleFill } from "react-icons/go";
import { MdBlock } from "react-icons/md";
import SuccessPage from "./SuccessPage";
import Spinner from "../components/Spinner";
import CivilIdDocument from "./CivilIdDocument";

const DocumentPage = () => {
  const { id } = useParams();
  const [formTwoData, setFormTwoData] = useState(initialFormData);
  const [formData, setFormData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formNotFound, setFormNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formStatus, setFormStatus] = useState("");
  const [errors, setErrors] = useState({});
  const [documentError, setDocumentError] = useState(false);
  const [documentErrorMsg, setDocumentErrorMsg] = useState("");
  const btnRef = useRef(null);

  const getStudent = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${BASE_URL}/student/admission/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const json = await response.json();
      console.log(json);
      if (json.status) {
        setFormStatus(json.data.student.admissionStatus);
        setFormData(json.data);
        setFormTwoData(prev => ({
          ...prev,
          nationality: { value: json.data.nationality }
        }));
        setFormNotFound(false);
      } else {
        setFormNotFound(true);
      }
    } catch (error) {
      console.error("Error fetching student:", error);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  if (formData?.document === null) {
    console.log("Null doc");
  } else {
    console.log("Not null doc");
  }
  console.log(formStatus);
  useEffect(() => {
    getStudent();
  }, [getStudent]);

  const handleChange = (e, firstKey, secondKey, thirdKey, forthKey) => {
    if (e.persist) e.persist();

    setFormTwoData((currentData) => {
      const value = e.target.value;
      const data = { ...currentData };
      let updateData = data;
      if (firstKey) {
        updateData = updateData[firstKey];
      }

      if (secondKey) {
        updateData = updateData[secondKey];
      }

      if (thirdKey) {
        updateData = updateData[thirdKey];
      }
      if (forthKey) {
        updateData = updateData[forthKey];
      }
      updateData.value = value;

      return data;
    });
  };

  const areAllDocumentsUploaded = () => {
    const isValidUploadedValue = (fileValue) => {
      if (!fileValue) return false;
      const isPdf = (val) => {
        if (typeof val === "string") return val.toLowerCase().endsWith(".pdf");
        if (typeof File !== "undefined" && val instanceof File) return val.name.toLowerCase().endsWith(".pdf") || val.type === "application/pdf";
        if (typeof Blob !== "undefined" && val instanceof Blob) return val.type === "application/pdf";
        if (typeof val === "object" && typeof val.name === "string") return val.name.toLowerCase().endsWith(".pdf");
        return false;
      };
      return isPdf(fileValue);
    };

    const requiredDocs = [
      "transcript",
      "englishscore",
      "birthCertificate",
      "civilidFront",
      "civilidBack",
      "passport",
      "photograph",
      "goodconduct",
      "fatherCivilId",
      "fatherPassport",
      "motherCivilId",
      "motherPassport"
    ];

    if (formData.nationality === "Non Kuwaiti") {
      requiredDocs.push("securityCardFront", "securityCardBack");
    } else if (formData.nationality === "Kuwait") {
      requiredDocs.push("sahel");
    }

    const failedDocs = requiredDocs.filter(doc => !isValidUploadedValue(formTwoData.document?.[doc]?.value));
    return failedDocs.length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!areAllDocumentsUploaded()) {
      setDocumentError(true);
      setDocumentErrorMsg("Please upload all required documents before proceeding.");
      return;
    }
    setDocumentError(false);
    setDocumentErrorMsg("");
    btnRef.current.disabled = true;

    const docFile = new FormData();
    docFile.append("id", id);
    docFile.append("photograph", formTwoData.document.photograph.value);
    docFile.append("transcript", formTwoData.document.transcript.value);
    docFile.append("englishscore", formTwoData.document.englishscore.value);
    docFile.append("highschool", formTwoData.document.highschool.value);
    docFile.append("civilidFront", formTwoData.document.civilidFront.value);
    docFile.append("civilidBack", formTwoData.document.civilidBack.value);
    docFile.append("securityFront", formTwoData.document.securityCardFront.value);
    docFile.append("securityBack", formTwoData.document.securityCardBack.value);
    docFile.append("passport", formTwoData.document.passport.value);
    docFile.append("record", formTwoData.document.record.value);
    docFile.append("goodconduct", formTwoData.document.goodconduct.value);
    docFile.append("fatherCivilId", formTwoData.document.fatherCivilId.value);
    docFile.append("motherCivilId", formTwoData.document.motherCivilId.value);
    docFile.append("sahel", formTwoData.document.sahel.value);
    docFile.append("equivalency", formTwoData.document.equivalency.value);
    docFile.append("birthCertificate", formTwoData.document.birthCertificate.value);
    docFile.append("fatherPassport", formTwoData.document.fatherPassport.value);
    docFile.append("motherPassport", formTwoData.document.motherPassport.value);
    docFile.append("otherDocuments", formTwoData.document.otherDocuments.value);

    for (let [key, value] of docFile.entries()) {
      if (value === null || value === undefined || value === "") {
        docFile.delete(key);
      }
    }

    try {
      setIsLoading(true);
      const docResponse = await fetch(`${BASE_URL}/student/admission/document/`, {
        method: "POST",
        body: docFile
      });

      const jsonDoc = await docResponse.json();
      console.log(jsonDoc);
      
      if (jsonDoc.status === true || jsonDoc.status) {
        setIsSubmitted(true);
      } else {
        btnRef.current.disabled = false;
        setDocumentError(true);
        setDocumentErrorMsg(jsonDoc.message || "Failed to upload documents.");
      }
    } catch (error) {
      console.error("Document upload failed:", error);
      btnRef.current.disabled = false;
      setDocumentError(true);
      setDocumentErrorMsg("An error occurred during upload. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {formStatus === "approved" ? (
        <AdmissionFormStatus
          icon={
            <GoCheckCircleFill className="md:text-[160px] text-[120px] text-[#52b69a]" />
          }
          message="Application form is approved"
        />
      ) : formStatus === "rejected" ? (
        <AdmissionFormStatus
          icon={
            <GoXCircleFill className="md:text-[160px] text-[120px] text-[#d93939]" />
          }
          message="Application form one is rejected"
        />

      ) : formNotFound ? (
        <AdmissionFormStatus
          icon={
            <GoXCircleFill className="md:text-[160px] text-[120px] text-[#d93939]" />
          }
          message="Application form not found"
        />
      ) : isSubmitted ? (
        <SuccessPage redirectURL={"/"} />
      ) : (formStatus === "preapproved" || formStatus === "pending") ? (
        <>
          {isLoading && <Spinner />}{" "}
          <Box sx={{}}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                backgroundColor: "#B70042",
                padding: "1rem",
                fontWeight: "bold"
              }}
            >
              <h4 className="form">Documents</h4>
            </Box>

            <CivilIdDocument
              showError={false}
              documentError={documentError}
              documentErrorMsg={documentErrorMsg}
              errors={errors}
              formData={formTwoData}
              handleChange={handleChange}
            />
            <div className="w-full">
              <button
                ref={btnRef}
                onClick={handleSubmit}
                className="bg-[#b70042] disabled:bg-rose-300 text-white font-bold px-10 py-3 rounded-lg mx-auto flex items-center my-6 hover:bg-rose-700"
              >
                Submit
              </button>
            </div>
          </Box>
        </>
      ) : formStatus === "" ? (
        <>{isLoading && <Spinner />}</>
      ) : (
        (window.location = `/`)
      )}
    </>
  );
};

export default DocumentPage;
